<template>
  <div>
    <TableHeaderCellDropdown @clear="onClear"
                             @open="load">
      <template v-slot:trigger-text>
        {{ $tResumesBaseResumes('Status') }}
      </template>
      <template v-if="selectedStatusId || selectedRange"
                v-slot:selected>
        <span v-if="selectedStatusId"
              class="table-header-cell-dropdown__selected-text">
          {{ +selectedStatusId }}
        </span>
        <span v-if="selectedRange"
              class="table-header-cell-dropdown__selected-text  _text">
          {{ selectedRange && selectedRange.join(' - ') }}
        </span>

      </template>
      <template v-slot:content="">
        <div class="table-header-cell-dropdown__options-wrap">
          <div class="table-header-cell-dropdown__options-section">
            <BasePreloader v-if="pending"/>

            <div class="table-header-cell-dropdown__options-section-title">
              {{ $tResumesBaseResumes('Status') }}
            </div>
            <div class="table-header-cell-dropdown__options-section-scroll-wrap">
              <ScrollView class="table-header-cell-dropdown__options-section-scroll">
                <BaseRadioList :value="selectedStatus"
                               :options="items"
                               text-key="name"
                               columns
                               @input="onInputStatus"/>
              </ScrollView>
            </div>
          </div>
          <div class="table-header-cell-dropdown__options-section">
            <div class="table-header-cell-dropdown__options-section-title">
              {{ $tResumesBaseResumes('Interval') }}
            </div>
            <APResumesBaseResumePageHeadRowStatusDateRange :value="selectedRange"
                                                           :routeKey="routeKeyRange"
                                                           @input="onRangeInput"
                                                           @clear="onClear(routeKeyRange)"/>
          </div>
        </div>
      </template>
    </TableHeaderCellDropdown>
    <BaseHelp width="23.3rem"
              :title="$tResumesBaseResumes('What does it mean')"
              :value="$tResumesBaseResumes('What does it mean text')"
              style="margin-left: 1.8rem"
              class="_top"/>
  </div>
</template>

<script>
  import {http} from '@/axios'
  import ScrollView from '@/components/ScrollView'
  import TableHeaderCellDropdown from '@/components/TableHeaderCellDropdown'
  import APResumesBaseResumePageHeadRowStatusDateRange
    from '@/components/partnerResumeBaseResumes/APResumesBaseResumePageHeadRowStatusDateRange'

  export default {
    name: 'APResumesBaseResumePageHeadRowStatus',
    components: {
      ScrollView,
      TableHeaderCellDropdown,
      APResumesBaseResumePageHeadRowStatusDateRange,
    },
    props: {
      routeKeyStatus: String,
      routeKeyRange: String,
      apiLink: String,
    },
    data() {
      return {
        items: null,
        pending: false,
        loaded: false,
      }
    },
    computed: {
      selectedStatusId() {
        return this.$route.query[this.routeKeyStatus]
      },
      selectedStatus() {
        const statusIs = this.selectedStatusId
        if (!statusIs || !this.items) return null

        return this.items.find(item => Number(statusIs) === item.key)
      },
      selectedRange() {
        const range = this.$route.query[this.routeKeyRange]
        if (!range) return null

        return range.split('|')
      }
    },
    methods: {
      load() {
        if (this.loaded || this.pending) return

        this.pending = true

        http.get(this.apiLink)
          .then(({data}) => {
            this.items = data.data
            this.loaded = true
          })
          .finally(() => {
            this.pending = false
          })
      },
      onInputStatus(value) {
        const query = {
          ...this.$route.query,
        }

        query[this.routeKeyStatus] = value.key

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      onClear(routeKey) {
        const query = {
          ...this.$route.query,
        }

        if (routeKey) {
          delete query[routeKey]
        } else {
          delete query[this.routeKeyStatus]
          delete query[this.routeKeyRange]
        }

        this.$router.push({
          query
        }).catch(() => ({}))
      },
      onRangeInput(value) {
        if (!value) {
          return
        }

        const query = {
          ...this.$route.query,
        }

        query[this.routeKeyRange] = value.join('|')

        this.$router.push({
          query
        }).catch(() => ({}))
      }
    }
  }
</script>

<style lang="less">

</style>
